import { defineStore } from 'pinia';
import { authApi } from '@/api';

function safeJsonParse(raw, fallback = null) {
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem('eyc_token') || '',
    user: safeJsonParse(localStorage.getItem('eyc_user'), null),
  }),
  getters: {
    isLoggedIn: (state) => !!state.token,
    isAdmin: (state) => state.user?.role === 'super_admin',
    isCustomerAdmin: (state) => state.user?.role === 'customer_admin',
    isSupplierAdmin: (state) => state.user?.role === 'supplier_admin',
    isDeptUser: (state) => state.user?.role === 'dept_user',
    isDelivery: (state) => state.user?.role === 'delivery',
    customerId: (state) => state.user?.customerId,
    supplierId: (state) => state.user?.supplierId,
    isWechatBrowser: () => /MicroMessenger/i.test(navigator.userAgent),
    roleName: (state) => {
      const map = { super_admin: '超级管理员', customer_admin: '单位管理员', supplier_admin: '供应商管理员', dept_user: '科室用户', delivery: '送货员' };
      return map[state.user?.role] || '';
    },
  },
  actions: {
    async login(username, password, captchaId, captcha) {
      const res = await authApi.login({ username, password, captchaId, captcha });
      this.token = res.data.token;
      this.user = res.data.user;
      localStorage.setItem('eyc_token', this.token);
      localStorage.setItem('eyc_user', JSON.stringify(this.user));
      return res.data;
    },
    logout() {
      this.token = '';
      this.user = null;
      localStorage.removeItem('eyc_token');
      localStorage.removeItem('eyc_user');
    },
    async fetchUserInfo() {
      const res = await authApi.getUserInfo();
      this.user = res.data;
      localStorage.setItem('eyc_user', JSON.stringify(this.user));
    },
    async wechatLogin(token) {
      this.token = token;
      localStorage.setItem('eyc_token', token);
      await this.fetchUserInfo();
      return this.user;
    },
  },
});
